const propertyKeys = {
  all: ["properties"],
  overview: () => [...propertyKeys.all, "overview"],
  byId: (id) => [...propertyKeys.all, id, "details"],
};

export default propertyKeys;
